<template>
    <v-card>
        <div class="th-p-8 th-pt-20 th-p-24-md th-pt-40-md">
            <h3 class="text-center th-mt-8">
                {{ $translation.t("Terms and Conditions") }}
            </h3>
            <p class="text-center th-mt-8 th-mb-24">
                {{
                    $translation.t(
                        "To continue, you must agree to the TermsHub Terms of Services, Privacy Policy"
                    )
                }}
            </p>
            <v-form ref="preferencesForm">
                <v-checkbox
                    class="m-0"
                    v-model="agree"
                    ref="agreeToTerms"
                    :rules="[inputRules.required]"
                    hide-details="auto"
                >
                    <template v-slot:label>
                        <div v-html="$translation.t('terms.and.conditions.agreement')"></div>
                    </template>
                </v-checkbox>
                <v-checkbox
                    class="m-0"
                    v-model="emailCommunication"
                    hide-details="auto"
                >
                    <template v-slot:label>
                        <p>
                            {{ $translation.t("Subscribe me to newsletter") }}
                        </p>
                    </template>
                </v-checkbox>
            </v-form>
            <p v-if="error" class="th-mt-12 text-danger" v-html="$translation.t(error)"></p>
            <div class="th-mt-24 text-right">
                <v-btn
                    color="primary"
                    @click="updatePreferences"
                    :loading="loading"
                >
                    {{ $translation.t("Save") }}
                </v-btn>
            </div>
        </div>
    </v-card>
</template>

<script>
import inputRules from "@/utils/inputRules";
export default {
    name: "TermsAgree",
    data: () => ({
        inputRules,
        agree: true,
        emailCommunication: false,
        error: null,
        loading: false,
    }),
    methods: {
        async updatePreferences() {
            if (!this.$refs.preferencesForm.validate()) return;

            try {
                await this.$axios.put("/api/v1/user/preferences", {
                    agreed_to_terms: this.agree,
                    subscribed_to_newsletter: this.emailCommunication,
                });

                this.$emit("close");
            } catch (e) {
                this.error = e.response.data.message;
            }
        },
    },
};
</script>

<style scoped></style>
